import Module from '@/store/resource/common/module';
import Messages from '@/store/resource/messages';

let module = new Module(new Messages());

export default module.create();
